import WellBeingBranchModal from './WellBeingBranchModal'

export default WellBeingBranchModal
